module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "cc-loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "top-page"
  }, [_c('div', {
    staticClass: "cc-inside"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.msg) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-inside"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        title: 'Here my awesome title'
      }),
      expression: "{title: 'Here my awesome title'}"
    }],
    staticClass: "push-item"
  }, [_c('span', {
    staticClass: "push-icon cc-bg-primary"
  }, [_c('i', {
    staticClass: "ion-android-contacts"
  })]), _vm._v(" "), _c('div', {
    staticClass: "push-infos"
  }, [_c('p', {
    staticClass: "push-title"
  }, [_vm._v("\n                              Users\n                          ")]), _vm._v(" "), _c('p', {
    staticClass: "push-number cc-primary"
  }, [_vm._v("\n                              " + _vm._s(_vm._f("formatNumber")(_vm.pushes.users, 0, ' ')) + "\n                          ")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "push-item"
  }, [_c('span', {
    staticClass: "push-icon cc-bg-green"
  }, [_c('i', {
    staticClass: "ion-android-cart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "push-infos"
  }, [_c('p', {
    staticClass: "push-title"
  }, [_vm._v("\n                              Sales\n                          ")]), _vm._v(" "), _c('p', {
    staticClass: "push-number cc-green"
  }, [_vm._v("\n                              " + _vm._s(_vm._f("formatMoney")(_vm.pushes.total, '€', 2, ' ', ',', '%v%s')) + "\n                          ")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "push-item"
  }, [_c('span', {
    staticClass: "push-icon cc-bg-purple"
  }, [_c('i', {
    staticClass: "ion-android-globe"
  })]), _vm._v(" "), _c('div', {
    staticClass: "push-infos"
  }, [_c('p', {
    staticClass: "push-title"
  }, [_vm._v("\n                              Other\n                          ")]), _vm._v(" "), _c('p', {
    staticClass: "push-number cc-purple"
  }, [_vm._v("\n                              " + _vm._s(_vm._f("formatNumber")(_vm.pushes.other, 2, ' ', ',')) + " %\n                          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns cc-align-start"
  }, [_c('div', {
    staticClass: "cc-8-m columns"
  }, [_c('div', {
    staticClass: "cc-12-m"
  }, [_c('div', {
    staticClass: "boxed widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h2', {
    staticClass: "cc-purple"
  }, [_vm._v("Monthly Average Temperature")])]), _vm._v(" "), _c('widget-highcharts-one')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cc-8-m"
  }, [_c('div', {
    staticClass: "boxed widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h2', {
    staticClass: "cc-orange"
  }, [_vm._v("Browsers statistics")])]), _vm._v(" "), _c('widget-highcharts-two')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cc-4-m"
  }, [_c('div', {
    staticClass: "boxed widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h2', {
    staticClass: "cc-red"
  }, [_vm._v("Users & Admins")])]), _vm._v(" "), _c('widget-highcharts-three')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cc-12-m"
  }, [_c('div', {
    staticClass: "boxed widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h2', {
    staticClass: "cc-primary"
  }, [_vm._v("Last registered users")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn cc-bg-primary",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('i', {
    staticClass: "ion-arrow-right-b"
  }), _vm._v(" "), _c('span', [_vm._v("Users list")])])], 1), _vm._v(" "), _c('widget-last-users')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cc-4-m"
  }, [_c('div', {
    staticClass: "boxed widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h2', {
    staticClass: "cc-yellow"
  }, [_vm._v("Widget 5")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-8-m"
  }, [_c('div', {
    staticClass: "boxed widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h2', {
    staticClass: "cc-blue"
  }, [_vm._v("Widget 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-12-m"
  }, [_c('div', {
    staticClass: "boxed widget"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h2', {
    staticClass: "cc-purple"
  }, [_vm._v("Widget 7")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cc-4-m widget-timeline"
  }, [_c('div', {
    staticClass: "widget boxed"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_c('h2', {
    staticClass: "cc-green"
  }, [_vm._v("\n                              Timeline\n                              "), _c('small', [_vm._v("\n                              • " + _vm._s(_vm.nbEventToShow) + " last events •\n                              ")])])]), _vm._v(" "), _c('widget-timeline', {
    attrs: {
      "nbItemToShow": _vm.nbEventToShow
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3116de43!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/dashboard/dashboard.vue
// module id = 219
// module chunks = 0